
<div id="notice-dialog" class="ui modal notice-modal">
  <div class="notice-modal__header">
    <div class="notice-modal__eyebrow">
      <span class="notice-modal__info-dot" aria-hidden="true">⚠</span>
      <span>重要なお知らせ</span>
    </div>
    <h2 class="notice-modal__title">直電の仕組み・紹介手数料についてのご案内</h2>
  </div>

  <div class="scrolling content notice-modal__body">
    <div class="notice-modal__panel">
      <div class="notice-modal__agreement-head">
        <h3 class="notice-modal__agreement-title">確認対象：直電の仕組み・紹介手数料について</h3>
        <span class="notice-modal__required-badge">確認必須</span>
      </div>

      <div class="notice-modal__agreement-inner">
        <p class="notice-modal__intro">
          平素より、グルプラをご利用いただき、誠にありがとうございます。<br />
          施設様に安心してサービスをご利用いただくため、グルプラの「直電」の仕組みと「紹介手数料」の考え方について、改めてご案内いたします。<br />
          お手数ですが、以下の内容をご確認ください。
        </p>

        <article>
          <div class="notice-modal__section-heading">
            <div class="notice-modal__section-number">1</div>
            <h3 class="notice-modal__section-title">直電について</h3>
          </div>
          <div class="notice-modal__section-content">
            <p>
              直電とは、グルプラ上の施設ページや電話導線から、ユーザーが施設様へ直接お電話できる仕組みです。
            </p>
            <p>
              「今すぐ空き状況を確認したい」「電話で相談したい」「そのまま予約したい」といったユーザーを施設様へスムーズにつなぐことで、予約機会を逃さないことを目的としています。
            </p>
            <p>
              また、問い合わせ内容の確認、成約確認、トラブル防止、サービス品質向上のため、通話内容を録音する場合があります。録音された通話内容は、店舗管理画面の「直電詳細」ページから、AIによる要約や自動文字起こしとあわせてご確認いただけます。
            </p>
            <p>
              直電をきっかけに宴会・貸切・パーティー等の予約が成立した場合は、グルプラ経由の送客として、ご契約内容に基づき紹介手数料の請求対象となります。
            </p>
            <p>
              直電の仕組みについては、以下の動画でもご案内しております。
            </p>
            <a
              class="notice-modal__video-link"
              href="https://youtu.be/JoKvdjoL9b8"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span class="notice-modal__play-icon" aria-hidden="true">▶</span>
              <span>
                <span class="notice-modal__video-title">直電の仕組みについて（動画）</span>
                <span class="notice-modal__video-url">https://youtu.be/JoKvdjoL9b8</span>
              </span>
            </a>
          </div>
        </article>

        <article>
          <div class="notice-modal__section-heading">
            <div class="notice-modal__section-number">2</div>
            <h3 class="notice-modal__section-title">紹介手数料について</h3>
          </div>
          <div class="notice-modal__section-content">
            <p>
              グルプラでは、ご契約内容に基づき、成約金額をもとに紹介手数料を算出しております。
            </p>
            <p>
              紹介手数料は、契約で定めた手数料率を成約金額に適用して算出し、その紹介手数料に対して消費税を加算してご請求いたします。
            </p>
            <p>
              この消費税は、グルプラが施設様へ提供する送客・紹介サービスに対して課税されるものであり、成約金額に含まれる消費税へ重ねて課税するものではありません。
            </p>
            <p>
              紹介手数料の考え方については、以下の動画でもご案内しております。
            </p>
            <a
              class="notice-modal__video-link"
              href="https://youtu.be/vLE5m-beIvM"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span class="notice-modal__play-icon" aria-hidden="true">▶</span>
              <span>
                <span class="notice-modal__video-title">紹介手数料について（動画）</span>
                <span class="notice-modal__video-url">https://youtu.be/vLE5m-beIvM</span>
              </span>
            </a>
          </div>
        </article>

        <section class="notice-modal__confirmation-box" aria-labelledby="notice-confirmation-title">
          <h3 class="notice-modal__confirmation-title" id="notice-confirmation-title">確認内容</h3>
          <ul class="notice-modal__confirmation-list">
            <li>直電は、グルプラ経由でユーザーが施設様へ直接電話できる仕組みであること</li>
            <li>直電では、問い合わせ内容の確認、成約確認、トラブル防止、サービス品質向上のため、通話内容を録音する場合があること</li>
            <li>録音された通話内容は、店舗管理画面から確認できること</li>
            <li>直電経由で予約・成約した場合は、ご契約内容に基づき紹介手数料の請求対象となること</li>
            <li>紹介手数料は、ご契約内容に基づいて算出され、その紹介手数料に対して消費税が加算されること</li>
          </ul>
          <div class="notice-modal__note">
            <strong>※</strong>
            <span>動画は補足説明です。動画をご視聴いただかなくても、上記内容をご確認いただければ確認手続きを行えます。</span>
          </div>
          <p class="notice-modal__support-text">
            ご不明な点がございましたら、ご契約内容や該当案件の通話内容を確認のうえ、個別にご説明いたしますので、お気軽にグルプラサポートまでお問い合わせください。
          </p>
        </section>
      </div>
    </div>
  </div>

  <div class="actions notice-modal__footer">
    <div class="notice-modal__check-panel">
      <label class="notice-modal__confirm-check">
        <input type="checkbox" v-model="confirmed">
        <span>
          <span class="notice-modal__required">必須</span>
          上記の内容を確認しました。
        </span>
      </label>
    </div>
    <div class="notice-modal__actions">
      <div class="notice-modal__status-text">
        {{ confirmed ? '確認内容の保存に進めます。' : 'チェックを入れると「確認して閉じる」を押せます。' }}
      </div>
      <button
        class="ui button notice-modal__primary-button"
        type="button"
        :class="{ disabled: !confirmed || submitting }"
        :disabled="!confirmed || submitting"
        @click="acknowledge"
      >
        確認して閉じる
      </button>
    </div>
  </div>
</div>
